import type { TabContent } from './page-reducer';

type Tab = {
  id: string;
  label: string;
  isActive: boolean;
  tabContent: TabContent;
};

export enum RevelioPageId {
  COMPANY_OVERVIEW = 'company-overview',
  COMPANY_OVERVIEW_V2 = 'company-overview-v2',
  COMPANY_SCREENER_V2 = 'company-screener-v2',
  COMPANY_COMPOSITION = 'company-composition',
  COMPANY_COMPOSITION_V2 = 'company-composition-v2',
  COMPANY_TRANSITIONS = 'company-transitions',
  COMPANY_TRANSITIONS_V2 = 'company-transitions-v2',
  COMPANY_POSTINGS = 'company-postings',
  COMPANY_PAY = 'company-pay',
  COMPANY_SENTIMENT = 'company-sentiment',
  GEOGRAPHY_OVERVIEW = 'geography-overview',
  GEOGRAPHY_SCREENER_V2 = 'geography-screener-v2',
  GEOGRAPHY_COMPOSITION = 'geography-composition',
  GEOGRAPHY_COMPOSITION_V2 = 'geography-composition-v2',
  GEOGRAPHY_TRANSITIONS = 'geography-transitions',
  GEOGRAPHY_TRANSITIONS_V2 = 'geography-transitions-v2',
  GEOGRAPHY_POSTINGS = 'geography-postings',
  GEOGRAPHY_PAY = 'geography-pay',
  GEOGRAPHY_SENTIMENT = 'geography-sentiment',
  REPORTS_OVERVIEW_SAMPLE = 'report-company-overview',
  REPORTS_ATTRITION_SAMPLE = 'report-company-attrition',
  REPORTS_SENTIMENT_SAMPLE = 'report-company-sentiment',
  REPORTS_MARKET_CONDITIONS_SAMPLE = 'report-company-market-conditions',
  REPORTS_ORG_HEALTH = 'report-org-health',
  ROLE_OVERVIEW = 'role-overview',
  ROLE_SCREENER_V2 = 'role-screener-v2',
  ROLE_COMPOSITION = 'role-composition',
  ROLE_COMPOSITION_V2 = 'role-composition-v2',
  ROLE_TRANSITIONS = 'role-transitions',
  ROLE_TRANSITIONS_V2 = 'role-transitions-v2',
  ROLE_POSTINGS = 'role-postings',
  ROLE_PAY = 'role-pay',
  ROLE_SENTIMENT = 'role-sentiment',
  TALENT_DISCOVERY = 'talent-discovery',
  POSTING_DISCOVERY = 'posting-discovery',
}

export const PAGES_WITH_AI_SEARCH: readonly RevelioPageId[] = [
  RevelioPageId.TALENT_DISCOVERY,
  RevelioPageId.POSTING_DISCOVERY,
  RevelioPageId.COMPANY_OVERVIEW_V2,
  RevelioPageId.COMPANY_SCREENER_V2,
  RevelioPageId.COMPANY_COMPOSITION,
  RevelioPageId.COMPANY_COMPOSITION_V2,
  RevelioPageId.COMPANY_TRANSITIONS,
  RevelioPageId.COMPANY_TRANSITIONS_V2,
  RevelioPageId.COMPANY_POSTINGS,
  RevelioPageId.COMPANY_PAY,
  RevelioPageId.COMPANY_SENTIMENT,
  RevelioPageId.GEOGRAPHY_OVERVIEW,
  RevelioPageId.GEOGRAPHY_SCREENER_V2,
  RevelioPageId.GEOGRAPHY_COMPOSITION,
  RevelioPageId.GEOGRAPHY_COMPOSITION_V2,
  RevelioPageId.GEOGRAPHY_TRANSITIONS,
  RevelioPageId.GEOGRAPHY_TRANSITIONS_V2,
  RevelioPageId.GEOGRAPHY_POSTINGS,
  RevelioPageId.GEOGRAPHY_PAY,
  RevelioPageId.GEOGRAPHY_SENTIMENT,
  RevelioPageId.ROLE_OVERVIEW,
  RevelioPageId.ROLE_SCREENER_V2,
  RevelioPageId.ROLE_COMPOSITION,
  RevelioPageId.ROLE_COMPOSITION_V2,
  RevelioPageId.ROLE_TRANSITIONS,
  RevelioPageId.ROLE_TRANSITIONS_V2,
  RevelioPageId.ROLE_POSTINGS,
  RevelioPageId.ROLE_PAY,
  RevelioPageId.ROLE_SENTIMENT,
] as const;

export enum PageType {
  REVELIO_PUBLIC = 'REVELIO_PUBLIC',
  PRIVATE = 'PRIVATE',
  REPORT = 'REPORT',
}

export type Owner = { id?: string; username?: string };

type BasePageConfig = {
  id: string;
  name: string;
  tabs: Tab[];
  owner: Owner;
};

export type RevelioPublicPageConfig = BasePageConfig & {
  type: PageType.REVELIO_PUBLIC;
  revelioPageId: RevelioPageId;
};

export type PrivatePageConfig = BasePageConfig & {
  type: PageType.PRIVATE;
  revelioPageId?: RevelioPageId;
};

export type ReportPageConfig = BasePageConfig & {
  type: PageType.REPORT;
  revelioPageId?: RevelioPageId;
  sampleFilterGroups?: string;
};

export type Page =
  | RevelioPublicPageConfig
  | PrivatePageConfig
  | ReportPageConfig;
